import React from "react";
import { Link } from "react-router-dom";

import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { SelectField } from "react-admin";

import { AclType, UserStatuses } from "../../../utils/constants";
import { UserStatusIcon } from "../users/UserStatusIcon";
import { isAuthorized } from "../../../utils/appUtils";

import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "16em",
      minWidth: "16em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  statusIcon: {
    marginTop: theme.spacing(-0.3),
  },
}));

export const CustomerAside = ({ backPath, record, ...props }) => {
  const classes = useStyles();
  const account = record?.reloadYardAccounts?.items[0];
  const linkBackPath = backPath
    ? [...backPath, props.location.pathname]
    : [props.location.pathname];

  if (!record) return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status:
            </Typography>
            <Grid container direction="row">
              <Grid item xs={2}>
                <UserStatusIcon record={record} classes={classes.statusIcon} />
              </Grid>
              <Grid item xs={10} className={classes.status}>
                <SelectField
                  source="status"
                  record={record}
                  choices={UserStatuses}
                />
              </Grid>
            </Grid>
          </Grid>
          {account && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Account:
              </Typography>
              <br />
              {isAuthorized(AclType.ACCOUNTS) ? (
                <Link
                  to={{
                    pathname: `/accounts/${account.accountId}`,
                    state: { backPath: linkBackPath },
                  }}
                >
                  <Typography variant="body2" color="primary">
                    {accountNameRenderer(account)}
                  </Typography>
                </Link>
              ) : (
                <Link
                  to={{
                    pathname: `/accounts/${account.accountId}/show`,
                    state: { backPath: linkBackPath },
                  }}
                >
                  <Typography variant="body2" color="primary">
                    {account.accountName}
                  </Typography>
                </Link>
              )}
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
